import { LinearGradient } from 'expo-linear-gradient';
import styled from 'styled-components/native';
import getPlatformType from '../../helpers/helpers';
import { COLORS, LAYOUT, BORDER_RADIUS } from '../../constants/theme';

var layoutType = getPlatformType();

let Container, GradientView, GradientWrapper, NameText, SelectedItem, ItemText, CornerView;

if (layoutType === 'web') {
  Container = styled.View`
    height: 15;
  `;

  GradientView = styled(LinearGradient)`
    display: none;
  `;

  // White sidebar for web — Figma design
  GradientWrapper = styled.View`
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: ${LAYOUT.sidebarWidth}px;
    min-height: 100vh;
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 24px;
    padding-top: 0px;
    background-color: ${COLORS.sidebarBg};
    border-right-width: 1px;
    border-right-color: ${COLORS.border};
  `;

  NameText = styled.Text`
    font-size: 13px;
    font-weight: 600;
    color: ${COLORS.textSecondary};
    margin-left: 8px;
    margin-top: 0;
  `;

  SelectedItem = styled.View`
    width: 100%;
    margin-top: 4px;
    height: 44px;
    background-color: ${(props) => (props.selected ? COLORS.primary : 'transparent')};
    border-radius: ${BORDER_RADIUS.md}px;
    flex-direction: row;
    align-items: center;
    padding-left: 12px;
    padding-right: 12px;
  `;

  ItemText = styled.Text`
    font-size: 14px;
    font-weight: ${(props) => (props.selected ? '700' : '500')};
    color: ${(props) => (props.selected ? '#FFFFFF' : COLORS.sidebarInactiveText)};
    margin-left: 10px;
  `;

  CornerView = styled.View`
    display: none;
  `;

} else if (layoutType === 'tab') {
  GradientView = styled(LinearGradient)`
    display: none;
  `;

  CornerView = styled.View`
    display: none;
  `;

  // Icon-only sidebar for tablet
  GradientWrapper = styled.View`
    position: absolute;
    left: 0px;
    top: 0;
    bottom: 0;
    height: 100vh;
    width: ${LAYOUT.sidebarWidthTab}px;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 24px;
    background-color: ${COLORS.sidebarBg};
    border-right-width: 1px;
    border-right-color: ${COLORS.border};
    align-items: center;
  `;

  NameText = styled.Text`
    font-size: 11px;
    color: ${COLORS.textSecondary};
    margin-top: 0;
    text-align: center;
  `;

  SelectedItem = styled.View`
    width: 48px;
    height: 48px;
    margin-top: 8px;
    background-color: ${(props) => (props.selected ? COLORS.primary : 'transparent')};
    border-radius: ${BORDER_RADIUS.lg}px;
    align-items: center;
    justify-content: center;
  `;

  ItemText = styled.Text`
    font-size: 10px;
    color: ${(props) => (props.selected ? '#FFFFFF' : COLORS.sidebarInactiveText)};
    margin-top: 2px;
    text-align: center;
  `;

} else {
  // Phone — fallback for hamburger drawer menu
  GradientView = styled(LinearGradient)`
    display: none;
  `;

  CornerView = styled.View`
    display: none;
  `;

  GradientWrapper = styled.View`
    flex: 1;
    width: 100%;
    background-color: ${COLORS.sidebarBg};
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 32px;
  `;

  NameText = styled.Text`
    font-size: 16px;
    color: ${COLORS.textPrimary};
    margin-top: 24px;
    font-weight: 700;
  `;

  SelectedItem = styled.View`
    width: 100%;
    margin-top: 4px;
    height: 48px;
    background-color: ${(props) => (props.selected ? COLORS.primary : 'transparent')};
    border-radius: ${BORDER_RADIUS.md}px;
    flex-direction: row;
    align-items: center;
    padding-left: 16px;
  `;

  ItemText = styled.Text`
    font-size: 14px;
    font-weight: ${(props) => (props.selected ? '700' : '500')};
    color: ${(props) => (props.selected ? '#FFFFFF' : COLORS.sidebarInactiveText)};
    margin-left: 10px;
  `;
}

export { Container, GradientView, GradientWrapper, NameText, SelectedItem, ItemText, CornerView };
